import normalizeWheel from 'normalize-wheel'
import type { ObjectDirective } from 'vue'

const isFirefox =
  typeof navigator !== 'undefined' &&
  navigator.userAgent.toLowerCase().indexOf('firefox') > -1

const mousewheel = function (element: any, callback: Function) {
  if (element && element.addEventListener) {
    const fn = (event: Event) => {
      const normalized = normalizeWheel(event)
      // @ts-ignore
      callback && callback.apply(this, [event, normalized])
    }
    if (isFirefox) {
      element.addEventListener('DOMMouseScroll', fn)
    } else {
      element.onmousewheel = fn
    }
  }
}

const Mousewheel: ObjectDirective = {
  beforeMount (el, binding) {
    mousewheel(el, binding.value)
  }
}

export default Mousewheel
